var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-file',_vm._g(_vm._b({class:{
    'g-file-input': true,
    'g-file-input-empty': !Boolean(_vm.$attrs.value),
  },attrs:{"placeholder":_vm.$attrs.placeholder || 'Choose a custom file',"drop-placeholder":_vm.$attrs.dropPlaceholder || 'Drop file here...'},on:{"input":function($event){return _vm.$emit('input', $event)}}},'b-form-file',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }